import type { FunctionComponent } from 'react';
import React from 'react';
import type { Navigation } from '@noths/polaris-dev-ts-types';

import { LinkCarousel, LinkCarouselType } from 'src/components/organisms/LinkCarousel';
import * as styles from '../styles';

interface AccordionContentProps {
  categoryDescription: string;
  navigation: Navigation[];
  enableCopyBlockContent: boolean;
}

export const AccordionContent: FunctionComponent<AccordionContentProps> = ({
  categoryDescription,
  navigation,
  enableCopyBlockContent = true,
}: AccordionContentProps) => (
  <>
    {enableCopyBlockContent && (
      <div css={styles.copyBlockContentCSS}>
        <div dangerouslySetInnerHTML={{ __html: categoryDescription }} />
      </div>
    )}
    {navigation[0] && (
      <section css={styles.linksCarouselSection}>
        <div css={[styles.insetSectionContent, styles.linksCarouselWrapper]}>
          <LinkCarousel
            id="categories"
            title="Categories"
            carouselType={LinkCarouselType.ChildCategory}
            links={navigation[0].options}
          />
        </div>
      </section>
    )}
  </>
);
